module.exports = __webpack_public_path__ + "assets/img/title-827ce47e.png";